<template>
<div class="row animated fadeIn">
  <div class="col-md-8 offset-md-2">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-align-justify"></i> <strong>Lista de Configurações</strong>
        <router-link :to="'/rocket/configuration'" class="btn btn-secondary btn-sm pull-right" exact>
          <i class="fa fa-plus"></i> Nova Configuração
        </router-link>
      </div>
      <div class="card-block">
        <table class="table table-bordered">
          <thead class="thead-inverse">
            <tr>
              <th>Configuração</th>
              <th>Última Atualização</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in configurations" :key="rowIndex">
              <td>
                <router-link :to="'configuration/' + row.id">{{ row.name }}</router-link>
              </td>
              <td>{{row.lastUpdated | formatDate}}</td>
              <td class="actions" >
                <button type="button" class="btn btn-link" @click="showModal(row)" style="margin:0"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>

        <modal title="Modal title" class="modal" v-model="deleteModal" @ok="deleteModal = false" effect="fade/zoom">
          <div slot="modal-header" class="modal-header">
            <span class="modal-title"><strong>Excluir Configuração</strong></span>
          </div>
          <div slot="modal-body" class="modal-body">Deseja excluir a configuração: <strong>{{ configuration.name }}</strong>?</div>
          <div slot="modal-footer" class="modal-footer">
            <button type="button" class="btn btn-sm btn-default" @click="deleteModal = false">Cancelar</button>
            <button type="button" class="btn btn-sm btn-danger" @click.prevent="deleteConfiguration">Confirmar</button>
          </div>
        </modal>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import modal from 'vue-strap/src/Modal'

export default {
  name: 'configurations',
  components: {
    modal
  },
  data () {
    return {
      loading: false,
      deleteModal: false,
      configuration: {},
      configurations: []
    }
  },
  created () {
    this.getConfigurations()
  },
  methods: {
    getConfigurations () {
      axios.get(process.env.ROCKET_API_URL + 'configurations', {
        withCredentials: true,
        headers: { Authorization: this.accessKey }}).then(response => {
          this.configurations = response.data.results
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao carregar as configurações.')
        })
    },
    deleteConfiguration () {
      this.deleteModal = false
      this.configuration.removed = true
      axios.delete(process.env.ROCKET_API_URL + 'configurations/' + this.configuration.id, {
        withCredentials: true,
        headers: { Authorization: this.accessKey,
          'Content-Type': 'application/json' }}).then(response => {
            this.showSuccess('Configuração excluída com sucesso')
            this.getConfigurations()
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao excluir a configuração.')
          })
    },
    showModal (row) {
      this.configuration = row
      this.deleteModal = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?3aab90ea